"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateReportStatus = exports.fetchReportListFailure = exports.fetchReportListSuccess = exports.fetchReportListRequest = exports.clearReportList = void 0;
const ReportListActionTypes = require("../../actionTypes/reports/list");
const clearReportList = () => ({
    type: ReportListActionTypes.CLEAR_REPORT_LIST
});
exports.clearReportList = clearReportList;
const fetchReportListRequest = (customerId, entryType) => ({
    type: ReportListActionTypes.FETCH_REPORT_LIST_REQUEST,
    payload: { customerId, entryType }
});
exports.fetchReportListRequest = fetchReportListRequest;
const fetchReportListSuccess = (reports) => ({
    type: ReportListActionTypes.FETCH_REPORT_LIST_SUCCESS,
    payload: reports
});
exports.fetchReportListSuccess = fetchReportListSuccess;
const fetchReportListFailure = (error) => ({
    type: ReportListActionTypes.FETCH_REPORT_LIST_FAILURE,
    error
});
exports.fetchReportListFailure = fetchReportListFailure;
const updateReportStatus = (payload) => ({
    type: ReportListActionTypes.UPDATE_REPORT_STATUS,
    payload
});
exports.updateReportStatus = updateReportStatus;
//# sourceMappingURL=list.js.map